import React from "react";
import "react-toastify/dist/ReactToastify.css";
import PinkTickCardSecond from "./PinkTickCardSecond";
import CountryCardSecond from "./CountryCardSecond";

const EcomerceCountryPage = () => {
  return (
    <>
      {/* Hero Section */}
      <section
        className="relative text-white min-h-[80vh] flex items-center justify-center overflow-hidden"
        style={{
          background:
            "linear-gradient(90deg,rgba(252, 53, 236, 1) 0%, rgba(237, 0, 170, 1) 100%)",
        }}
      >
        <div
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1616692474781-9ef0114c15b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
          }}
        ></div>

        <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold uppercase tracking-tight font-[Aeonik]">
            Pink Help
          </h1>
          <h1 className="text-4xl sm:text-5xl mt-4 md:text-6xl font-extrabold tracking-tight font-[Aeonik]">
            <span className="text-black mt-12">Ecommerce Portal</span>
          </h1>
        </div>
      </section>

      {/* Main Content */}
      <section className="min-h-screen py-16 px-4 sm:px-10 bg-gradient-to-b from-white to-gray-100 text-gray-800">
        <div className="max-w-6xl mx-auto p-4">
          <div className="flex flex-col md:flex-row items-center md:items-start gap-10">
            {/* Left Side: Content */}
            <div className="flex-1 text-center items-center md:text-left">
              {/* Portal Description */}
              <h2 className="text-2xl sm:text-3xl font-bold text-[#ED00AA] mb-4">
                Pink Help
              </h2>
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-700 mb-3">
              Ecommerce Portal
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto md:mx-0 mb-3">
                List your service or become an exclusive product vendor in one
                of our 10 core categories designed to empower women across
                .
              </p>
              <p className="text-gray-600 max-w-2xl mx-auto md:mx-0 mb-6 font-medium">
                You are now viewing the <strong>[Ecommerce]</strong> gateway
                for Pink Help — powered by Women of the World, Inc.
              </p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto my-10 px-4 md:px-0">
          <div className="bg-white border flex items-center text-center border-pink-300 shadow-xl rounded-2xl p-6 transition-transform duration-300 hover:scale-[1.02] hover:shadow-pink-200">
            <PinkTickCardSecond />
          </div>

          <div className="bg-white border border-blue-300 shadow-xl rounded-2xl p-6 transition-transform duration-300 hover:scale-[1.02] hover:shadow-blue-200">
            <CountryCardSecond />
          </div>
        </div>
      </section>
    </>
  );
};

export default EcomerceCountryPage;
